import { AppliedAdjustment } from './applied-adjustment';
import { Transaction } from './transaction';
import { AdjustmentSummary } from './adjustment-summary';

export class Summary extends Transaction {
  appliedAdjustments: AppliedAdjustment[];
  adjustmentSummaries: AdjustmentSummary[];
}
